<template>
  <div class="ml-1 pet-details-tile bg-white">
    <button class="close back mt-3 ml-2 bg-light back-arrow" style="float:left">
      <b-icon-arrow-left @click="$emit('close')" />
    </button>
    <button class="close mt-2 mr-2 bg-light">
      <b-icon-x @click="$emit('close')" />
    </button>
    <section class="ml-4 mt-3">
      <div class="">
        <h4 class="text-black-50 ml-40px">
          Hunde Steckbrief
        </h4>
      </div>

      <div class="d-flex mt-2">
        <div class="badges-container">
          <div>
            <div class="d-block">
              <div v-if="pet.hasSubscription" class="has-subscription">
                Abo
              </div>
              <div v-if="pet.isPuppy" class="is-puppy center-middle">Welpe</div>
            </div>
          </div>
        </div>
        <div class="w-100 center-middle">
          <div class="d-block">
            <div
              :style="'background:url(\'' + pet.image + '\') no-repeat center'"
              class="rounded-circle pet-pic"
            />
            <h5 class="mt-4 d-block pet-name">{{ pet.name }}</h5>
          </div>
          <div class="clickable" @click="showPictureUpload">
            <i
              class="fas fa-cloud-upload-alt mx-auto d-block"
              style="color: #e3e3e3; font-size: 40px"
              aria-hidden="true"
            />
            <a style="font-size: 14px;" class="futalis-text-green font-weight-normal d-block">Hundebild<br />hochladen</a>
          </div>
        </div>
      </div>

      <div class="font-details">
        <h6 class="futalis-text-green">Patientendaten</h6>

        <div class="pet-info-container" :style="{ 'height': `${resizableBoxSize}px` }">
          <Characteristics
            :pet="petCharacteristics"
            :options="{ showClientName: false, showPetName: false }"
          />
          <div @click="$emit('deletePet',pet.id)" class="mt-2 d-flex text-uppercase clickable" style="color: #aaa;">
            Patient entfernen <i class="ml-2 mt-1 fas fa-trash-can"/>
          </div>
        </div>
      </div>
    </section>
    <div>
      <div class="d-block mt-4 mb-2">
        <div class="d-flex">
          <div class="px-1 w-100">
            <button
                class="font-buttons btn-block futalis-btn futalis-button-orange"
                @click="navigateToConfigurator(pet.id)"
            >
              Anamnese & Futterberechnung
            </button>
          </div>
        </div>
        <div class="d-flex">
          <div class="w-50 px-1 mt-1">
            <button
                @click="handleOnRationResultClick"
                class="font-buttons btn-block futalis-btn futalis-button-gray"
            >
              Ernährungsberatung
            </button>
          </div>
          <div class="w-50 mt-1 px-1">
            <button
                class="font-buttons btn-block futalis-btn futalis-button-blue"
                @click="showIntensiveCare"
            >
              intensive care
            </button>
          </div>
        </div>
        <div class="d-flex">
          <div class="w-50 px-1 mt-1">
            <button
                :disabled="pet.lastOrderItemId == 0"
                @click="tryReorder()"
                class="font-buttons btn-block futalis-btn futalis-button-green px-0"
                :class="{ 'bg-gray': pet.lastOrderItemId == 0 }"
            >
              Nachbestellen
            </button>
          </div>
          <div class="w-50 mt-1 px-1">
            <button
              class="font-buttons btn-block futalis-btn futalis-bg-dark-green"
              :class="{ 'bg-gray': pet.customerDocs == '' }"
              @click="openNewTab(pet.customerDocs)"
              id="Adressbcustdocs-button"
            >
              <i class="fal fa-print ml-3" style="color:white;font-size:1.5em;display:block;float:left" id="Adressbcustdocs-icon" />
              Dokumente
            </button>
          </div>
        </div>
      </div>
    </div>

    <IntensiveCare
      v-if="displayIntensiveCare"
      :weight="pet.targetWeight"
      :petName="pet.name"
      :petId="pet.id"
      @getIntensiveCareProducts="getIntensiveCareProducts"
      @close="closeIntensiveCare"
    />
    <PictureUpload
      v-if="displayPictureUpload"
      v-model="petPicture"
      @close="closePictureUpload"
      :pet="pet"
    />
    <WeightPopup
      v-if="displayWeightPopup"
      :pet="pet"
      @close="closeWeightPopup"
      @recalculate="recalculate"
      @reorder="reorder"
    />
  </div>
</template>

<script>
import router from '@/modules/router/config';
import IntensiveCare from '@/components/common/IntensiveCare';
import PictureUpload from '@/components/common/PictureUpload';
import Characteristics from '@/components/common/Characteristics';
import WeightPopup from '@/components/scenes/addressBook/WeightPopup';
import { CONSTANTS } from '@/constants/guide';
import { displaySubscriptionWarning } from '@/helpers/siteHelper';

export default {
  name: 'PetDetails',
  components: { PictureUpload, IntensiveCare, WeightPopup, Characteristics },
  props: ['pet', 'closeAddressBook', 'uploadPicture', 'clientId'],
  data() {
    return {
      displayIntensiveCare: false,
      displayPictureUpload: false,
      displayWeightPopup: false,
      ReorderKey: null,
      resizableBoxSize: window.innerWidth <= 768 ? window.innerHeight - 400 : 340,
    };
  },
  methods: {
    handleOnRationResultClick() {
      this.closeAddressBook();
      router.push({
        name: `RationResults`,
        params: {
          petId: this.pet.id,
          skipLeaveCartPopup: true
        }
      });
    },
    getIntensiveCareProducts() {
      this.$store.dispatch('homeModule/getIntensiveCareProducts');
    },
    openNewTab(link) {
      window.open(link, '_blank');
    },
    recalculate() {
      this.$store.commit('homeModule/displayFloatingDots');
      if (this.ReorderKey) {
        const reorderItems = this.ReorderKey.split('-');
        const reorderKey =
          (reorderItems[3] === 'sub' ? '1' : '0') +
          '-' +
          reorderItems[0] +
          '-' +
          reorderItems[1];
        location.href =
          '/futalisshop/mydogs/loadCustomerPet/id/' +
          this.pet.id +
          '/interface/1/step/6/option/' +
          reorderKey;
      } else {
        location.href =
          '/futalisshop/mydogs/loadCustomerPet/id/' +
          this.pet.id +
          '/interface/1/step/6';
      }
    },
    tryReorder(skipSubscriptionAsk) {
      if (skipSubscriptionAsk == null && this.pet.hasSubscription == true) {
        displaySubscriptionWarning(() => {
          this.tryReorder(1);
        });
        return;
      }
      if (this.pet.bcs != 3 || this.pet.isPuppy) {
        this.showWeightPopup();
        return;
      }
      this.reorder();
    },
    reorder() {
      this.$store.commit('homeModule/displayFloatingDots');
      this.$store
        .dispatch('addressBookModule/reorder', this.pet.id)
        .then(promise => {
          if (promise.success === true) {
            this.$store.commit('homeModule/displayFloatingDots');
            this.closeAddressBook();

            gtag("event", "add_to_cart", {
              currency: "EUR",
              value: promise.item.price * promise.item.quantity,
              items: [
                {
                  id: 5,
                  item_name: 'Ration',
                  affiliation: 'ration',
                  discount: 0,
                  item_category: 'interface',
                  item_category2: promise.item.package_type == 1 ? 'daily' : 'weekly',
                  item_category3: promise.item.number_of_days_weeks,
                  item_variant: promise.item.is_subscription == 1 ? 'Futter-Abo' : 'Einzelbestellung',
                  price: promise.item.price,
                  quantity: promise.item.quantity,
                  google_business_vertical: 'retail'
                }
              ]
            });

            if (this.$route.name !== 'checkout') {
              router.push({
                name: `checkout`
              });
            } else {
              this.$store.commit('checkOutModule/putCartContent', {
                needsRefresh: true
              });
            }
          } else if (typeof promise.redirect_url != 'undefined') {
            location.href = promise.redirect_url;
          } else if (promise.error) {
            alert(promise.error);
          }
        });
    },
    navigateToConfigurator(petId) {
      this.closeAddressBook();
      router.push({
        name: `Configurator`,
        params: {
          mode: CONSTANTS.CONFIGURATOR.MODES.EDIT_PET,
          id: petId,
          skipLeaveCartPopup: true
        }
      });
    },
    showIntensiveCare() {
      this.displayIntensiveCare = true;
      document.body.style.overflow = 'hidden';
    },
    closeIntensiveCare() {
      this.displayIntensiveCare = false;
      document.body.style.overflow = '';
    },
    showWeightPopup() {
      this.displayWeightPopup = true;
      document.body.style.overflow = 'hidden';
    },
    closeWeightPopup() {
      this.displayWeightPopup = false;
      document.body.style.overflow = '';
    },
    showPictureUpload() {
      this.displayPictureUpload = true;
      document.body.style.overflow = 'hidden';
    },
    closePictureUpload() {
      this.displayPictureUpload = false;
      document.body.style.overflow = '';
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.onResize);
    },
    onResize() {
      this.resizableBoxSize = window.innerWidth <= 768 ? window.innerHeight - 400 : 340;
    }
  },
  computed: {
    petPicture: {
      get() {
        return this.pet.image;
      },
      set(value) {
        this.uploadPicture({ image: value, petId: this.pet.id });
        this.closePictureUpload();
      }
    },
    petCharacteristics() {
      return {
        ...this.pet,
        illnesses: Object.keys(this.pet?.illnesses),
        allergies: Object.keys(this.pet?.allergies),
        additives: Object.keys(this.pet?.additives)
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.onResize);
    });
  },
};
</script>

<style scoped>
.pet-details-tile {
  width: 320px;
  height: 768px;
}
.pet-info-container {
  width: 100%;
  height: 340px;
  overflow: auto;
}
@media (max-width: 768px) {
  .pet-details-tile {
    height: calc(100vh - 5px) !important;
    width: 100% !important;
    position: absolute;
    top: 0;
    margin-left: 0 !important;
  }
  .pet-name {
    margin: 0 !important;
  }
  .pet-info-container {
    /*height: calc(100vh - 400px) !important;*/
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .pet-info-container::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
}

.pet-pic {
  width: 140px;
  height: 140px;
  background-size: auto 100% !important;
}

.upload-new-pic > span > a {
  font-size: 0.8rem;
  color: #a8c014;
}

.font-14 {
  font-size: 14px;
}

.badges-container {
  position: relative;
  font-size: 15px;
  font-weight: bold;
  text-transform: uppercase;
}

.badges-container > div {
  position: absolute;
  top: 0;
  left: -20px;
  right: 0;
  bottom: 50px;
  align-items: center; /* align vertical */
  text-align: center;
  display: flex;
}

.has-subscription {
  color: #ebbb04;
  border: 2px solid #ebbb04;
}
.is-puppy,
.has-subscription {
  border-radius: 15px;
  width: 70px;
  padding-top: 3px;
}

.is-puppy {
  color: #57c1d5;
  margin-top: 10px;
  border: 2px solid #57c1d5;
}

.font-details {
  font-size: 0.8rem;
}
.font-buttons {
  padding: 0.45rem 0;
  font-size: 0.9rem !important;
}
br {
  line-height: 22px;
}
</style>
